import React, { Component } from 'react'

export class VerticalDivider extends Component {

    render() {
        return <div className="divider" />
    }
}
